module.exports = require('./dist/rate-adjustment');
